export function BlogSkeletonCard() {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-border/50 bg-card shadow-sm sm:flex-row">
      <div className="h-36 shrink-0 animate-pulse bg-muted sm:h-auto sm:w-44" />
      <div className="flex-1 p-4 sm:p-5">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <div className="h-5 w-56 animate-pulse rounded bg-muted" />
            <div className="flex gap-3">
              <div className="h-3.5 w-24 animate-pulse rounded bg-muted/60" />
              <div className="h-3.5 w-20 animate-pulse rounded bg-muted/60" />
            </div>
          </div>
          <div className="h-6 w-20 animate-pulse rounded-full bg-muted" />
        </div>
        <div className="mt-3 space-y-1.5">
          <div className="h-3.5 w-full animate-pulse rounded bg-muted/40" />
          <div className="h-3.5 w-3/4 animate-pulse rounded bg-muted/40" />
        </div>
      </div>
    </div>
  );
}
